import React from 'react'
import Layout from '../Layout'
import CartComponent from '../../../utils/CommonFunctionality/Cart'
import './Cart.css'
import SEO from '../../../utils/CommonFunctionality/SEO'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const Cart = (props) => {
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'
    return (
        <>
            {isPrimeBids ? (
                <SEOTAG page="Cart" />
            ) : (
                <SEO title={`${global?.storeDetails?.name} | Cart`} />
            )}
            <Layout props={props}>
                <div className="cartOuterWrapper">
                    <CartComponent props={props} currency="cad" />
                </div>
            </Layout>{' '}
        </>
    )
}

export default Cart
